<template>
	<div class="container2">
		<div class="head">
			<div class="head1">
				<div class="head1-img"></div>
				<!-- <div class="head1-text">能量工厂官网</div> -->
				<div class="head1-text">酒店宝</div>
			</div>
			<div class="head2">
				<el-tabs v-model="activeName" @tab-click="handleClick">
				    <!-- <el-tab-pane label="首页" name="0"></el-tab-pane> -->
				    <!-- <el-tab-pane label="共享充电宝加盟" name="1"></el-tab-pane> -->
					<!-- <el-tab-pane label="酒店宝" name="1"></el-tab-pane> -->
				    <!-- <el-tab-pane label="共享充电线" name="2"></el-tab-pane> -->
					
				    <!-- <el-tab-pane label="热度充电宝" name="3"></el-tab-pane> -->
					<!-- <el-tab-pane label="产品展示" name="4"></el-tab-pane> -->
					<!-- <el-tab-pane label="关于我们" name="3"></el-tab-pane> -->
				  </el-tabs>
			</div>
		</div>
		<!-- <div class="main">
			
		</div> -->
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeName: '0'
			}
		},
		computed:{
			
		},
		mounted(){
			if(this.activeName ==0){
				console.log('000')
				this.$router.push("/");
			}
		},
		methods: {
			handleClick(tab, event) {
				this.activeName = tab.index;
				console.log('this.activeName',this.activeName);
				if(this.activeName ==0){
					console.log('000')
					this.$router.push("/");
				}else if(this.activeName ==1){
					// this.$router.push("/aboutmy");
					this.$router.push("/treasure");
				}else if(this.activeName ==2){
					this.$router.push("/chargingjoin");
				}else if(this.activeName ==3){
					// this.$router.push("/aboutmy");
					this.$router.push("/product");
				}
				
				// else if(this.activeName ==3){
				// 	this.$router.push("/powerbank");
				// }else if(this.activeName ==4){
				// 	this.$router.push("/product");
				// }else if(this.activeName ==5){
					
				// }
				// if(this.activeName ==0){
				// 	console.log('000')
				// 	this.$router.push("/");
				// }else if(this.activeName ==1){
				// 	this.$router.push("/chargingjoin");
				// }else if(this.activeName ==2){
				// 	this.$router.push("/cable");
				// }else if(this.activeName ==3){
				// 	this.$router.push("/powerbank");
				// }else if(this.activeName ==4){
				// 	this.$router.push("/product");
				// }else if(this.activeName ==5){
				// 	this.$router.push("/aboutmy");
				// }
				
			},
		}
	}
</script>

<style scoped>
	.container2{
		background: #e5e5e5;
		border-bottom: 1px solid #ddd;
		border-radius: 5px;
	}
	.head {
		height: 60px;
		display: flex;
		align-items: center;
		background-color: #ffffff;
		justify-content: space-around;
	}

	.head1 {
		/* padding-left: 30px; */
		width: 30%;
	}
	.head2{
		display: flex;
		/* align-items: center; */
		/* width: 70%; */
	}

	.head1-text {
		color: #1f87ec;
		font-size: 24px;
		font-weight: bold;
	}
    ::v-deep .el-tabs__nav-wrap::after {
	height: 0px;
    }
	/* /deep/ .el-tabs__nav-scroll{
		line-height: 70px;
	} */
	/deep/ .el-tabs__nav{
		height: 60px;
	}
	/deep/ .el-tabs__item{
		line-height: 60px;
	}
	/deep/ .el-tabs__header{
		margin: 0px;
	}
</style>